import Api from '../config/api'

export const findAllCid10Subcategoria = (searchDTO = {}) => {
  const defaultSearchDTO = {
    pageSize: 30,
    pageNumber: 0,
    sortDir: 'ASC',
  }

  return Api.post('', {
    query: `query ($searchDTO: SearchDTOInput) {
      findAllCid10Subcategoria(searchDTO: $searchDTO) {
        last
        totalElements
        numberOfElements
        content {
          id
          descricao
          codigo
          descricaoAbreviada
        }
      }
    }`,
    variables: {
      searchDTO: { ...defaultSearchDTO, ...searchDTO },
    },
  })
}

export const findAllTussView = ({ search, tabela, codigo, descricao, pageableDTO }) => {
  const defaultPageableDTO = {
    pageSize: 30,
    pageNumber: 0,
    sortDir: 'ASC',
    sortField: 'descricao',
  }

  return Api.post('', {
    query: `query ($search: String, $tabela: Int, $pageableDTO: PageableDTOInput, $codigo: String, $descricao: String) {
      findAllTussView(search: $search, tabela: $tabela, pageableDTO: $pageableDTO, codigo: $codigo, descricao: $descricao) {
        last
        totalElements
        numberOfElements
        content {
          codigoTermo
          descricao
          tabela
        }
      }
    }`,
    variables: {
      search,
      tabela,
      codigo,
      descricao,
      pageableDTO: pageableDTO || defaultPageableDTO,
    },
  })
}

export const findAllTuss22ProcedimentoEventoSaude = variables => {
  return Api.post('', {
    query: `query ($codigoTermo: String, $tiposProcedimentos: [TipoProcedimento], $ativo: Boolean, $descricao: String, $pageableDTO: PageableDTOInput) {
      findAllTuss22ProcedimentoEventoSaude(
        codigoTermo: $codigoTermo
        tiposProcedimentos: $tiposProcedimentos
        ativo: $ativo
        descricao: $descricao
        pageableDTO: $pageableDTO
      ) {
        last
        totalElements
        numberOfElements
        content {
          id
          codigoTermo
          descricao
          localOdontograma {
            tipo
            id
          }
        }
      }
    }`,
    variables: {
      ...variables,
      tiposProcedimentos: 'ODONTOLOGICO',
    },
  })
}

export const findGuiaServicoById = id => {
  return Api.post('', {
    query: `query ($id: UUID!) {
      findByIdGuiaServicoTGO(id: $id) {
        id
        beneficiarioCns
        beneficiarioConvenioNumeroCarteira
        beneficiarioConvenioValidadeCarteira
        beneficiarioNome
        cid10Subcategoria {
          descricaoAbreviada
        }
        dataHoraLancamento
        solicitanteNome
        profissionalSaude {
          numeroConselho
          ufConselho
          conselhoProfissionalSaude {
            sigla
          }
        }
        sujeitoAtencao {
          dataNascimento
        }
        observacao
        guiaServicoTGOTussViews {
          quantidadeSolicitada
          face
          quantidadeSolicitadaUnidadeServico
          localOdontograma {
            id
            tipo
          }
          tussView {
            codigoTermo
            descricao
            tabela
          }
        }
      }
    }`,
    variables: { id },
  })
}

export const findGuiaServicoByIdEntradaProntuario = id => {
  return Api.post('', {
    query: `query ($id: Long) {
      content: findGuiaServicoTGOByIdEntradaProntuario(id: $id) {
        id
        assinado
        beneficiarioCns
        beneficiarioConvenioNumeroCarteira
        beneficiarioConvenioValidadeCarteira
        beneficiarioNome
        cid10Subcategoria {
          id
          descricaoAbreviada
        }
        solicitanteNome
        profissionalSaude {
          numeroConselho
          ufConselho
          conselhoProfissionalSaude {
            sigla
          }
        }
        sujeitoAtencao {
          dataNascimento
        }
        entradaProntuario {
          urlDownload
        }
        dataHoraLancamento
        observacao
        guiaServicoTGOTussViews {
          quantidadeSolicitada
          quantidadeSolicitadaUnidadeServico
          face
          localOdontograma {
            tipo
            id
          }
          tussView {
            codigoTermo
            descricao
            tabela
          }
        }
      }
    }`,
    variables: { id },
  })
}

export const findAllLocalOdontogramaGeral = variables => {
  return Api.post('', {
    query: `query ($localOdontograma: [Long]) {
      findAllLocalOdontogramaGeral(localOdontograma: $localOdontograma) {
        id
        codigo
        descricao
        local
      }
    }`,
    variables,
  })
}

export const findCodigosDisponiveisTussView = ({ tabela, pageableDTO }) => {
  const defaultPageableDTO = {
    pageSize: 30,
    pageNumber: 0,
    sortDir: 'ASC',
  }

  return Api.post('', {
    query: `query ($tabela: Int, $pageableDTO: PageableDTOInput) {
      findCodigosDisponiveisTussView(tabela: $tabela, pageableDTO: $pageableDTO) {
        last
        totalElements
        content {
          codigoTermo
          descricao
          tabela
        }
        pageable {
          pageNumber
        }
      }
    }`,
    variables: {
      tabela,
      pageableDTO: pageableDTO || defaultPageableDTO,
    },
  })
}

export const findAllGuiaServicoTussViewQuantidadeUso = pageableDTO => {
  const defaultPageableDTO = {
    pageSize: 30,
    pageNumber: 0,
    sortDir: 'DESC',
  }

  return Api.post('', {
    query: `query ($pageableDTO: PageableDTOInput) {
      findAllGuiaServicoTGOTussViewQuantidadeUso(pageableDTO: $pageableDTO) {
        last
        numberOfElements
        content {
          quantidadeUso
          localOdontograma {
            tipo
            id
          }
          face
          localTipoId
          tussView {
            codigoTermo
            descricao
            tabela
          }
        }
        pageable {
          pageNumber
        }
      }
    }`,
    variables: {
      pageableDTO: pageableDTO || defaultPageableDTO,
    },
  })
}

export const findGuiaServicoModeloById = id => {
  return Api.post('', {
    query: `query ($id: UUID) {
      findGuiaServicoModeloTGOById(id: $id) {
        id
        ativo
        nome
        observacao
        cid10Subcategoria {
          id
          descricaoAbreviada
        }
        guiaServicoModeloTgoTussViews {
          quantidadeSolicitada
          quantidadeSolicitadaUnidadeServico
          face
          localOdontograma {
            tipo
            id
          }
          tussView {
            codigoTermo
            descricao
            tabela
          }
        }
      }
    }`,
    variables: { id },
  })
}

export const createGuiaServicoTGO = variables => {
  return Api.post('', {
    query: `mutation ($guiaServicoTgo: GuiaServicoTGOInput) {
      createGuiaServicoTGO(guiaServicoTGO: $guiaServicoTgo) {
        id
        beneficiarioCns
        beneficiarioConvenioNumeroCarteira
        beneficiarioConvenioValidadeCarteira
        beneficiarioNome
        cid10Subcategoria {
          descricaoAbreviada
        }
        dataHoraLancamento
        solicitanteNome
        profissionalSaude {
          numeroConselho
          ufConselho
          conselhoProfissionalSaude {
            sigla
          }
        }
        sujeitoAtencao {
          dataNascimento
        }
        observacao
        guiaServicoTGOTussViews {
          quantidadeSolicitada
          face
          quantidadeSolicitadaUnidadeServico
          localOdontograma {
            id
            tipo
          }
          tussView {
            codigoTermo
            descricao
            tabela
          }
        }
      }
    }`,
    variables,
  })
}

export const createGuiaServicoModeloTGO = variables => {
  return Api.post('', {
    query: `mutation ($guiaServicoModeloTgo: GuiaServicoModeloTGOInput) {
      createGuiaServicoModeloTGO(guiaServicoModeloTGO: $guiaServicoModeloTgo) {
        id
        nome
        observacao
        quantidadeUso
        ativo
        cid10Subcategoria {
          id
          descricaoAbreviada
        }
        guiaServicoModeloTgoTussViews {
          quantidadeSolicitada
          quantidadeSolicitadaUnidadeServico
          face
          localOdontograma {
            tipo
            id
          }
          tussView {
            codigoTermo
            descricao
            tabela
          }
        }
      }
    }`,
    variables,
  })
}

export const updateGuiaServicoModeloTGO = variables => {
  return Api.post('', {
    query: `mutation ($guiaServicoModeloTgo: GuiaServicoModeloTGOInput) {
      updateGuiaServicoModeloTGO(guiaServicoModeloTGO: $guiaServicoModeloTgo) {
        id
        nome
        observacao
        ativo
        guiaServicoModeloTgoTussViews {
          quantidadeSolicitada
          quantidadeSolicitadaUnidadeServico
          face
          localOdontograma {
            tipo
            id
          }
          tussView {
            codigoTermo
            descricao
            tabela
          }
        }
        cid10Subcategoria {
          id
          descricaoAbreviada
        }
      }
    }`,
    variables,
  })
}

export const ativarGuiaServicoModeloTGO = id => {
  return Api.post('', {
    query: `mutation ($id: UUID) {
      ativarGuiaServicoModeloTgo(id: $id) {
        id
        nome
        ativo
      }
    }`,
    variables: { id },
  })
}

export const inativarGuiaServicoModeloTGO = id => {
  return Api.post('', {
    query: `mutation ($id: UUID) {
      inativarGuiaServicoModeloTgo(id: $id) {
        id
        nome
        ativo
      }
    }`,
    variables: { id },
  })
}

export const registroQuantidadeUsoModeloTGO = id => {
  return Api.post('', {
    query: `mutation ($id: UUID) {
      createGuiaServicoModeloTgoQuantidadeUso(id: $id) {
        id
        nome
        ativo
        quantidadeUso
      }
    }`,
    variables: { id },
  })
}

export const findAllGuiaServicoModeloTGO = filter => {
  return Api.post('', {
    query: `query ($searchDTO: SearchDTOInput, $pageableDTO: PageableDTOInput) {
      findAllGuiaServicoModeloTGO(searchDTO: $searchDTO, pageableDTO: $pageableDTO) {
        last
        numberOfElements
        content {
          id
          nome
          observacao
          ativo
          cid10Subcategoria {
            id
            descricaoAbreviada
          }
          guiaServicoModeloTgoTussViews {
            quantidadeSolicitada
            quantidadeSolicitadaUnidadeServico
            face
            localOdontograma {
              tipo
              id
            }
            tussView {
              codigoTermo
              descricao
              tabela
            }
          }
        }
        pageable {
          pageNumber
        }
      }
    }`,
    variables: {
      searchDTO: {
        search: filter?.search || '',
        ativo: filter?.ativo,
      },
      pageableDTO: {
        pageSize: 30,
        pageNumber: filter?.pageNumber || 0,
        sortDir: filter?.sortDir || 'ASC',
        sortField: filter?.sortField || 'nome',
      },
    },
  })
}

export const criarEImprimirGuiaServicoAssinado = variables => {
  return Api.post('', {
    query: `mutation ($guiaServico: GuiaServicoInput, $tokenAplicativo: String) {
      criarEImprimirGuiaServicoTGOAssinado(guiaServico: $guiaServico, tokenAplicativo: $tokenAplicativo) {
        id
        entradaProntuario {
          urlDownload
        }
      }
    }`,
    variables,
  })
}

export const imprimirAssinadoGuiaServico = variables => {
  return Api.post('', {
    query: `mutation ($id: UUID, $tokenAplicativo: String) {
      imprimirAssinadoGuiaServicoTGO(id: $id, tokenAplicativo: $tokenAplicativo) {
        id
        entradaProntuario {
          urlDownload
        }
      }
    }`,
    variables: {
      id: variables.guiaServico.id,
      tokenAplicativo: variables.tokenAplicativo,
    },
  })
}
